import { ReplyOrder } from '@diritto/common/reply/constants';
import { useGetRelayProfileRepliesInfiniteQuery } from 'queries/reply/useGetRelayProfileRepliesInfiniteQuery';
import React, { useCallback } from 'react';
import { useGetReplyInfo } from 'state-hooks/reply/useGetReplyInfo';
import { InfiniteScrollWrapper } from 'ui-components/common/InfiniteScrollWrapper';
import { FullPageLoading } from 'ui-components/common/Loading';
import { ReplyList } from 'app-components/reply/list/ReplyList';
import styled from '@emotion/styled';
import { useRouter } from 'next/navigation';
import { buildEpisodeReplyUrl } from 'utils/url';
import { RepliesRelayResponseDto } from '@diritto/common/relay/dtos/reply-relay.dtos';
import { ReplyRelayDto } from '@diritto/common/relay/dtos/episode-reply-relay.dto';

interface ProfileReplyListProps {
  profileId: number;
}

export const ProfileReplyList = ({ profileId }: ProfileReplyListProps) => {
  const replyQuery = useGetRelayProfileRepliesInfiniteQuery(profileId, ReplyOrder.Latest);
  const { replies, episodes, contents, profiles, likeReplyIds } = useGetReplyInfo<RepliesRelayResponseDto>(replyQuery);
  const router = useRouter();

  const handleClickReply = useCallback((reply: ReplyRelayDto) => router.push(buildEpisodeReplyUrl(reply)), [router]);

  return (
    <StyledInfiniteScrollWrapper hasNext={replyQuery.hasNextPage} loadMore={replyQuery.fetchNextPage}>
      {replyQuery.isLoading && <FullPageLoading relative />}
      <ReplyList
        profiles={profiles}
        replies={replies}
        contents={contents}
        episodes={episodes}
        likeReplyIds={likeReplyIds}
        myReplyEditable={false}
        myReplyDeletable
        showReReplyWrite
        showReReplyCount
        showMyReplyStyle={false}
        showPinned={false}
        showContentInfo
        onClickReply={handleClickReply}
        emptyDescription={'댓글이 없어요'}
      />
    </StyledInfiniteScrollWrapper>
  );
};

const StyledInfiniteScrollWrapper = styled(InfiniteScrollWrapper)`
  margin-bottom: 200px;
`;
